module.exports = __webpack_public_path__ + "static/media/modulos.049d683d.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/modulos.png
// module id = 47
// module chunks = 0